module.exports = __webpack_public_path__ + "img/menu.1d6880d5.png";